import React, { useEffect, useRef, useState } from 'react'
import { createMarkupWithOption } from '../../../models/Common'
import  {
  IConfirmationModalProps,
} from '../../common/ConfirmationModal'

import PopupModal from '../../common/Modal'
export interface IWorkplaceGlossaryModalProps {
  show: boolean
  title: string
  content: string
  onConfirm: () => void
}

const WorkplaceGlossaryModal = (props: IWorkplaceGlossaryModalProps) => {
  const mountedRef = useRef(false)
  const [content, setContent] = useState<string>()
  const [, setTitle] = useState<string>()
  const [modal, setModal] = useState<IConfirmationModalProps>({
    title: '',
    confirmText: 'Ok',
    cancelText: '',
    isOpen: props.show,
    hideCancelButton: true,
  })

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setModal((prevState) => ({
        ...prevState,
        title: props.title,
        isOpen: props.show,
      }))
      setTitle(props.title)
      setContent(props.content)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.show, props.content])

  const close = () => {
    setModal((prevState) => ({
      ...prevState,
      isOpen: false,
    }))
    props.onConfirm()
  }

  return (
    <>
      <PopupModal {...modal} onConfirm={close} onCancel={close}>
        <div
          dangerouslySetInnerHTML={createMarkupWithOption(content, {
            ADD_ATTR: ['target'],
          })}
        ></div>
      </PopupModal>
    </>
  )
}

export default WorkplaceGlossaryModal
